import { Navigate } from "react-router";

import { useGetEntityTemplate } from "@/entities/entity-template";
import { AssetTypeTemplateFormEditor } from "@/modules/asset-type-template/asset-type-template-form-editor";
import { AssetTypeTemplatePageHeader } from "@/modules/asset-type-template/asset-type-template-page-header";
import { getModelLink } from "@/modules/model";
import { isError404 } from "@/services/api";
import { useIdParam } from "@/services/router";

export const AssetTypeTemplatePage = () => {
  const id = useIdParam();
  const { isLoading, template, error } = useGetEntityTemplate(id);

  if (!id || isError404(error)) {
    return <Navigate to={getModelLink("technicalform")} replace />;
  }

  return (
    <>
      <AssetTypeTemplatePageHeader template={template} loading={isLoading} />
      <AssetTypeTemplateFormEditor template={template} loading={isLoading} />
    </>
  );
};
